import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SECTIONS } from '../shared/section';
import { BUSINESS_INFO } from '../shared/data/business.data';

@Component({
  selector: 'lumiron-imprint',
  templateUrl: './imprint.component.html',
  styleUrl: './imprint.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SECTIONS],
})
export class ImprintComponent {
  protected readonly business = BUSINESS_INFO;
}
